import React from 'react';
import { RichText } from '../components/richText';
import styled from 'styled-components';
import { Asset } from '../types/asset';
import { Header, HeaderProps } from '../components/sections/header';
import { Document } from '@contentful/rich-text-types';
import { FooterProps, Footer } from '../components/sections/footer';
import { VLink } from '../components/other/vLink';
import { Layout } from '../components/layout';
import { HeroBlog } from '../components/sections/heroBlog';
import Helmet from 'react-helmet';
import {BlogLayout} from '../components/blogLayout';

const Container = styled.div``;

interface Author {
  name: string;
  image: Asset;
  bio: string;
  website: string;
  twitter: string;
  linkedin: string;
}

interface Category {
  fields: {
    title: string,
    slug: string,
  };
}

interface PageProps {
  pageContext: {
    blogPost: {
      title: string;
      description: string;
      content: Document;
      backgroundImage: Asset;
      publishedOn: string;
      type: string;
      categories: Category[];
      author: Author;
      additionalAuthor: Author;
      header: HeaderProps;
      footer: FooterProps;
    },
    relatedPosts: RelatedPost[],
  };
}

interface RelatedPost {
  title: string;
  slug: string;
  mainImage: Asset;
}
export default ({ pageContext, location }: PageProps) => {
  const { blogPost, relatedPosts } = pageContext;
  const { title, description, author, additionalAuthor, mainImage, publishedOn, backgroundImage, content, categories, header, footer } = blogPost;



  console.log('categories', categories);
  

  return (
    <BlogLayout title={title} description={description}>
      <Header logo={header.logo} navigationItems={header.navigationItems} navigation={header.navigation} disableInverse={false} />
      <Helmet>
          <title>{title}</title>
          <meta name="description" content={description} />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:creator" content={author.name} />
          <meta name="twitter:description" content={description} />
          <meta property="og:title" content={title} />
          <meta property="og:type" content="article" />
          <meta property="og:site_name" content="Vervaunt" />
          <meta property="og:description" content={description} />
          <meta name="image" property="og:image" content={`https:` + mainImage.url} />
          <meta name="image" property="twitter:image" content={mainImage.url} />
          <meta name="twitter:image" content={`https:` + mainImage.url} />
          <meta name="twitter:image:src" content={`https:` + mainImage.url} />
          <meta name="twitter:site" content="@Vervaunt" />
          <meta name="twitter:title" content={title} />
      </Helmet>
      <HeroBlog
          headline={title}
          subtitle={description}
          backgroundImage={backgroundImage}
          publishedOn={publishedOn}
          author={author}
          additionalAuthor={additionalAuthor}
          location={location}
      />
      <Container className="max-w-2xl pt-0 mx-auto mb-20">
        <RichText additionalClass={'blog__post--view px-6 md:px-0'} content={content} />
        <div className="px-10 pt-10 pb-8 md:px-0">
          <div className="mb-5 uppercase font-bold text-1.5xl">Categories</div>
          {categories && categories.map((category, index) => {
            const {title, slug} = category.fields

            return <div className="relative inline-block">
              <a className="inline-block uppercase text-1.5xl" href={`/category/${slug}`}>
              <div style={{
                textDecorationColor:"#46ff46",
                textDecorationThickness:"3px",
                textUnderlineOffset:"3px"}} className="underline">{title}</div>
              </a>
              {index !== categories.length -1 && 
                <span className="px-3 text-1.5xl">|</span>
              }

              </div>
            

          })}
        </div>

        {relatedPosts && (
          <div className="px-10 pt-10 pb-8 border-t border-black md:px-0">
            <div className="mb-8 uppercase font-bold text-1.5xl">You may also like</div>
            <div className="md:flex md:flex-wrap md:-mx-4">
              {relatedPosts.map((relatedPost, index) => {
                if (relatedPost) {

                  return (
                    <div key={index} className="relative inline-block mb-12 md:w-1/2 md:px-4">
                      <VLink className="inline-block" to={`/${relatedPost.slug}`}>
                        <div>
                          <img className="w-full mb-6" src={relatedPost.mainImage.url} alt={relatedPost.mainImage.name} />
                          <h3 className="mb-2 text-lg font-bold leading-tight">{relatedPost.title}</h3>
                        </div>
                      </VLink>
                    </div>
                  );

                }
            })}
            </div>
          </div>
        )}

      </Container>
      <Footer {...footer} />
    </BlogLayout>
  );
};
